import axios from "axios";
import { useState } from "react";
import { Typography } from "@material-tailwind/react";

export default function Home() {
  const [code, setCode] = useState("");
  const [output, setOutput] = useState("");
  const [language, setLanguage] = useState("cpp17"); // Default language set to cpp17
  const [userInput, setUserInput] = useState(""); // New state for user input

  const compileCode = async () => {
    const options = {
      method: "POST",
      url: "https://online-code-compiler.p.rapidapi.com/v1/",
      headers: {
        "content-type": "application/json",
        "X-RapidAPI-Key": "71e8ec7015mshf39288d256b4122p131e8djsn7212687a1259",
        "X-RapidAPI-Host": "online-code-compiler.p.rapidapi.com",
      },
      data: {
        language: language,
        version: "latest",
        code: code,
        input: userInput, // Added userInput here
      },
    };

    try {
      const response = await axios.request(options);
      setOutput(response.data.output || "No output.");
    } catch (error) {
      setOutput(
        "Error compiling code: " + (error.response ? error.response.data : ""),
      );
    }
  };

  return (
    <section className="min-h-screen bg-gray-200 py-16">
      <div className="container mx-auto px-6 " style={{ width: "86`vw" }}>
        <Typography
          variant="h2"
          className="mb-12 text-center font-bold text-[#1A237E]"
        >
          Online Compiler
          <span className="material-icons ml-2">new_releases</span>
          {/* This 'new_releases' icon can represent 'beta'. Adjust styling as needed. */}
        </Typography>

        <div className="grid gap-1 md:grid-cols-2" style={{ width: "86`vw" }}>
          <div
            className="rounded bg-white p-8 shadow-lg"
            style={{ width: "75vw" }}
          >
            <div className="mb-4">
              <label
                htmlFor="language"
                className="block text-lg font-medium text-gray-600"
              >
                Select Language:
              </label>
              <select
                id="language"
                className="mt-2 w-full rounded-md border p-2"
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
              >
                <option value="cpp17">C++17</option>
                <option value="python3">Python 3</option>
                <option value="java">Java</option>
                <option value="rust">Rust</option>
              </select>
            </div>

            <textarea
              id="code"
              style={{ height: "40.6rem", width: "39vw" }} // Custom styles for double height and wider width
              className="mt-4 resize-none rounded-md border bg-black p-2 text-white"
              placeholder={`Enter your ${language} code here...`}
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />

            <button
              className="mt-4 w-full transform rounded-md bg-blue-500 px-4 py-2 text-white transition hover:scale-105 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
              onClick={compileCode}
            >
              Compile
            </button>
          </div>
          <div className="rounded bg-white p-8 shadow-lg">
            <Typography variant="h2" className="mt-6 font-bold text-[#1A237E]">
              Input
            </Typography>

            <textarea
              id="userInput"
              className="mt-4 h-72 w-full resize-none rounded-md border bg-black p-4 text-white"
              placeholder="Enter your input here..."
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
            />

            <Typography variant="h2" className="mt-6 font-bold text-[#1A237E]">
              Output
            </Typography>

            <div className="mt-4 h-72 w-full overflow-auto rounded-md border bg-black p-4 text-white">
              {output}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
